module.exports = __webpack_public_path__ + "static/premium_pietro-f98414ff95d254889ffe907421eafe1e.jpg";